<template>
    <div class="delete-popup">
        <div class="popup-content">
            <div class="warning-icon">
                <img :src="deleteicon" alt="warning-icon" />
            </div>
            <h2>All of your recordings and notes will be deleted</h2>
            <p>Please ensure that the above data is backed up locally, as deletion is irreversible.</p>
            <p>Are you sure you want to proceed with deletion?</p>
            <div class="buttons">
                <button class="delete-btn" @click="deleteAccount">Delete Account</button>
                <button class="cancel-btn" @click="cancelDeletion">Cancel</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            deleteicon: require("@/assets/images/home/delete-icon.png")
        };

    },
    methods: {
        async deleteAccount() {
            // 触发删除账户逻辑
            try {
                const subid = this.$cookies.get("subid");
                const response = await this.$axios.post("/api/deleteuserinfo/", {
                    subid: subid,
                });
                const resdata = response.data;
                if (resdata.code == 200) {
                    this.logout();
                }

            } catch (error) {
                console.log(error);
            }
        },
        logout() {
            this.$cookies.remove("email");
            this.$cookies.remove("subid");
            this.$cookies.remove("userlogin");
            this.$cookies.remove("username");
            this.$router.push("/");
        },
        cancelDeletion() {
            // 取消删除操作
            this.$parent.isdeletepopup = false;
        }
    },

}
</script>
<style lang="less" scoped>
.delete-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;

    .popup-content {
        background-color: #ffffff;
        border-radius: 16px;
        padding: 32px;
        width: 90%;
        max-width: 580px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
        text-align: center;
        position: relative;

        h2 {
            color: #ff4d4f;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 16px;
            line-height: 1.4;
        }

        p {
            font-size: 15px;
            line-height: 1.6;
            margin-bottom: 12px;
            padding: 0;
            color: #666666;
        }

        .warning-icon {
            margin-bottom: 20px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 80px;
                height: 80px;
                object-fit: contain;
                filter: drop-shadow(0 4px 6px rgba(255, 77, 79, 0.2));
            }
        }

        .buttons {
            margin-top: 28px;
            display: flex;
            justify-content: center;
            gap: 16px;

            button {
                padding: 14px 0;
                flex: 1;
                font-size: 15px;
                font-weight: 600;
                border-radius: 12px;
                cursor: pointer;
                border: none;
                transition: all 0.2s ease;

                &.delete-btn {
                    background-color: #ff4d4f;
                    color: white;
                    box-shadow: 0 2px 8px rgba(255, 77, 79, 0.2);

                    &:hover {
                        background-color: #ff7875;
                        transform: translateY(-1px);
                        box-shadow: 0 4px 12px rgba(255, 77, 79, 0.3);
                    }
                }

                &.cancel-btn {
                    background-color: #f5f5f5;
                    color: #666666;
                    border: 1px solid #e0e0e0;

                    &:hover {
                        background-color: #ebebeb;
                        color: #333333;
                        transform: translateY(-1px);
                    }
                }
            }
        }
    }
}
</style>